import React, { useState, useEffect } from "react";
import styles from "./AnimatedNumber.module.css";

/**
 * Número rolante.
 *  - Mesma qtd de casas (ex.: 15 -> 16): só o(s) dígito(s) que mudam rolam.
 *  - Mudou a qtd de casas (ex.: 9 -> 10, 99 -> 100): rola o número inteiro,
 *    todos descem e os novos (com mais casas) entram por cima.
 *
 * Props:
 *   from:     number  — valor antigo (ex.: streak - 1)
 *   to:       number  — valor novo (ex.: streak)
 *   play:     boolean — dispara a rolagem
 *   lit:      boolean — false=cinza, true=laranja (transição de cor)
 *   duration: number  — ms da rolagem
 */
export default function AnimatedNumber({ from, to, play = false, lit = false, duration = 800 }) {
  const fromStr = String(from);
  const toStr = String(to);
  const sameLen = fromStr.length === toStr.length;

  const [rolling, setRolling] = useState(false);

  useEffect(() => {
    if (play) {
      // duplo rAF garante que o estado inicial (translateY -50%) seja pintado
      let raf2;
      const raf1 = requestAnimationFrame(() => {
        raf2 = requestAnimationFrame(() => setRolling(true));
      });
      return () => {
        cancelAnimationFrame(raf1);
        cancelAnimationFrame(raf2);
      };
    }
    setRolling(false);
  }, [play]);

  const style = { "--roll-dur": `${duration}ms` };
  const cls = `${styles.number} ${lit ? styles.lit : ""}`;

  // ---- modo mesma quantidade de casas: reels por posição ----
  if (sameLen) {
    return (
      <div className={cls} style={style}>
        {toStr.split("").map((nd, i) => {
          const od = fromStr[i];
          const changed = od !== nd;
          return (
            <span key={i} className={styles.reel}>
              <span
                className={[
                  styles.reelInner,
                  changed && rolling ? styles.roll : "",
                  !changed ? styles.static : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <span className={styles.digit}>{nd}</span>
                <span className={styles.digit}>{changed ? od : nd}</span>
              </span>
            </span>
          );
        })}
      </div>
    );
  }

  // ---- modo mudança de casas: rola o número inteiro ----
  return (
    <div className={cls} style={style}>
      <span className={styles.reelBlock}>
        <span className={`${styles.reelInner} ${rolling ? styles.roll : ""}`}>
          <span className={styles.digit}>{toStr}</span>
          <span className={styles.digit}>{fromStr}</span>
        </span>
      </span>
    </div>
  );
}